<router-outlet *ngIf = "showRouter"></router-outlet>

<app-report-download-alert
    (downloadBtn)="downloadCSVClicked($event)"
    [message]="alertMsg"></app-report-download-alert>
